
export class TableDataConstants {

    public static readonly TableDataMap = {
        INVMGMT: {
            headers:
                [
                    ['Sent to KSeF||A1:A1', 'Mode||B1:B1', 'Invoice Status||C1:C1', 'KSeF session ID||D1:D1', 'KSeF URL Address||E1:E1', 'Certificate Confirmation URL Address||F1:F1', 'UPO status||G1:G1', 'KSeF number||H1:H1', 'KSeF date||I1:I1', 'Invoice number||J1:J1', 'Offline24 due date||K1:K1',
                        'Seller EU prefix||L1:L1', 'Seller Tax ID||M1:M1', 'Seller name||N1:N1', 'Buyer Tax ID||O1:O1', 'Buyer name||P1:P1', 'Currency code||Q1:Q1',
                        'Date of issue||R1:R1', 'Sales date||S1:S1', 'Sales 23% - net||T1:T1', 'Sales 23% - VAT||U1:U1', 'Sales 8% - net||V1:V1', 'Sale 8% - VAT||W1:W1', 'Sale 5% - net||X1:X1',
                        'Sale 5% - VAT||Y1:Y1', 'Sales in the OSS procedure - net||Z1:Z1', 'Sales in the OSS procedure - VAT||AA1:AA1', 'Sales 0% - net||AB1:AB1', 'Exempt sales||AC1:AC1', 'Gross value||AD1:AD1', 'Attachment exist||AE1:AE1']
                ],
            columns:
                [
                    { key: 'sentToKsef', width: 15 },
                    { key: 'mode', width: 25 },
                    { key: 'invoiceStatus', width: 22 },
                    { key: 'ksefSessionId', width: 35 },
                    { key: 'ksefURLAddress', width: 35 },
                    { key: 'certificateURLAddress', width: 35 },
                    { key: 'upoStatus', width: 22 },
                    { key: 'ksefNumber', width: 35 },
                    { key: 'ksefDate', width: 22 },
                    { key: 'invoiceNumber', width: 15 },
                    { key: 'offline24DueDate', width: 25 },
                    { key: 'sellerEUPrefix', width: 15 },
                    { key: 'sellerTaxId', width: 15 },
                    { key: 'sellerName', width: 15 },
                    { key: 'buyerTaxId', width: 15 },
                    { key: 'buyerName', width: 15 },
                    { key: 'currencyCode', width: 15 },
                    { key: 'dateOfIssue', width: 15 },
                    { key: 'saleDate', width: 15 },
                    { key: 'sales23Net', width: 15 },
                    { key: 'sales23VAT', width: 15 },
                    { key: 'sales8Net', width: 15 },
                    { key: 'sale8VAT', width: 22 },
                    { key: 'sale5Net', width: 15 },
                    { key: 'sale5VAT', width: 15 },
                    { key: 'salesOssNet', width: 15 },
                    { key: 'salesOssVAT', width: 15 },
                    { key: 'sales0Net', width: 15 },
                    { key: 'exemptSales', width: 15 },
                    { key: 'grossValue', width: 15 },
                    { key: 'attachmentExist', width: 20 }
                ],
            cells:
                ['A1', 'B1', 'C1', 'D1', 'E1', 'F1', 'G1', 'H1', 'I1', 'J1', 'K1', 'L1', 'M1', 'N1', 'O1', 'P1', 'Q1', 'R1', 'S1', 'T1', 'U1', 'V1', 'W1', 'X1', 'Y1', 'Z1', 'AA1', 'AB1', 'AC1', 'AD1', 'AE1'],
            fileBaseName: 'InvoiceManagement_TableData_',
            formats:
                [
                    { key: 'sentToKsef', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'mode', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'invoiceStatus', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'ksefSessionId', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'ksefURLAddress', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'certificateURLAddress', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'upoStatus', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'ksefNumber', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'ksefDate', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'invoiceNumber', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'offline24DueDate', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'sellerEUPrefix', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'sellerTaxId', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'sellerName', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'buyerTaxId', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'buyerName', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'currencyCode', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'dateOfIssue', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'saleDate', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'sales23Net', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'sales23VAT', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'sales8Net', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'sale8VAT', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'sale5Net', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'sale5VAT', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'salesOssNet', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'salesOssVAT', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'sales0Net', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'exemptSales', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'grossValue', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'attachmentExist', isformat: false, isPipeFormat: false, default: "" }
                ]
        },
        INVMGMTRO: {
            headers:
                [
                    ['Sent To Mof||A1:A1', 'Upload Index||B1:B1', 'Download Index||C1:C1', 'Date Of Response||D1:D1', 'Company ID||E1:E1', 'Record Status||F1:F1', 'Retry Count||G1:G1',
                        'File ID||H1:H1', 'Seller Legal name||I1:I1', 'Seller VAT ID||J1:J1', 'Buyer Legal name||K1:K1', 'Buyer VAT ID||L1:L1', 'Invoice Type||M1:M1', 'Invoice Number||N1:N1',
                        'Invoice Currency Code||O1:O1', 'Invoice Date||P1:P1', 'VAT Point Date||Q1:Q1', 'Invoice VAT Taxable Amount||R1:R1', 'No Of Unique VAT rates||S1:S1', 'Invoice Total VAT amount||T1:T1',
                        'Invoice Total with VAT||U1:U1', 'Message Received||V1:V1']
                ],
            columns:
                [
                    { key: 'sentToMof', width: 15 },
                    { key: 'uploadIndex', width: 15 },
                    { key: 'downloadIndex', width: 15 },
                    { key: 'respDt', width: 15 },
                    { key: 'companyID', width: 15 },
                    { key: 'recordStatus', width: 22 },
                    {key: 'retry', width: 15 },
                    { key: 'fileId', width: 15 },
                    { key: 'sellerLegalName', width: 15 },
                    { key: 'sellerVATID', width: 22 },
                    { key: 'buyerLegalName', width: 15 },
                    { key: 'buyerVATID', width: 15 },
                    { key: 'invoiceType', width: 15 },
                    { key: 'invoiceNumber', width: 15 },
                    { key: 'invoiceCurrencyCode', width: 15 },
                    { key: 'invoiceDate', width: 15 },
                    { key: 'vatPointDate', width: 15 },
                    { key: 'invVatTaxableAmt', width: 15 },
                    { key: 'uniqueVatRate', width: 15 },
                    { key: 'invTotalVATAmt', width: 22 },
                    { key: 'invTotalVAT', width: 15 },
                    { key: 'msgReceived', width: 22 }
                ],
            cells:
                ['A1', 'B1', 'C1', 'D1', 'E1', 'F1', 'G1', 'H1', 'I1', 'J1', 'K1', 'L1', 'M1', 'N1', 'O1', 'P1', 'Q1', 'R1', 'S1', 'T1', 'U1', 'V1' ],
            fileBaseName: 'InvoiceManagement_TableData_',
            formats:
                [
                    { key: 'sentToMof', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'uploadIndex', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'downloadIndex', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'respDt', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'companyID', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'recordStatus', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'retry', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'fileId', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'sellerLegalName', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'sellerVATID', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'buyerLegalName', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'buyerVATID', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'invoiceType', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'invoiceNumber', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'invoiceCurrencyCode', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'invoiceDate', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'vatPointDate', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'invVatTaxableAmt', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'uniqueVatRate', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'invTotalVATAmt', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'invTotalVAT', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'msgReceived', isformat: false, isPipeFormat: false, default: "" }
                ]
        },
        INVMGMTFR: {
            headers:
                [
                    ['Sent to PA||A1:A1', 'Transaction Type||B1:B1', 'Transaction Sub Category||C1:C1', 'Document Number||D1:D1', 'GTES Status||E1:E1', 'Lifecycle Status||F1:F1', 'Lifecycle Action Taken||G1:G1', 'Lifecycle Action Status||H1:H1', 'PPF Status||I1:I1',
                        'File ID||J1:J1', 'Document Type||K1:K1', 'Document Date||L1:L1', 'Seller Name||M1:M1', 'Seller Legal ID||N1:N1', 'Buyer Name||O1:O1',
                        'Buyer Legal ID||P1:P1', 'Currency||Q1:Q1', 'Invoice Value||R1:R1', 'Taxable Amount||S1:S1', 'Tax Amount||T1:T1', 'Attachment Exist||U1:U1', 'Last Activity||V1:V1']
                ],
            columns:
                [
                    { key: 'sentToPA', width: 15 },
                    { key: 'transactionType', width: 20 },
                    { key: 'transactionSubCategory', width: 25 },
                    { key: 'invoiceNumber', width: 20 },
                    { key: 'gtesStatus', width: 18 },
                    { key: 'lifeCycleStatus', width: 18 },
                    { key: 'lifecycleActionTaken', width: 22 },
                    { key: 'lifecycleActionStatus', width: 22 },
                    { key: 'ppfStatus', width: 18 },
                    { key: 'fileId', width: 15 },
                    { key: 'docTyp', width: 15 },
                    { key: 'documentdate', width: 15 },
                    { key: 'sellerName', width: 20 },
                    { key: 'sellerVatId', width: 20 },
                    { key: 'buyerName', width: 20 },
                    { key: 'buyerVAT', width: 20 },
                    { key: 'documentCurrency', width: 15 },
                    { key: 'invoiceValue', width: 15 },
                    { key: 'taxableValue', width: 15 },
                    { key: 'taxAmount', width: 15 },
                    { key: 'attachUrlExcel', width: 18 },
                    { key: 'lastActivity', width: 20 }
                ],
            cells:
                ['A1', 'B1', 'C1', 'D1', 'E1', 'F1', 'G1', 'H1', 'I1', 'J1', 'K1', 'L1', 'M1', 'N1', 'O1', 'P1', 'Q1', 'R1', 'S1', 'T1', 'U1', 'V1'],
            fileBaseName: 'TableData_OutwardInvoices_',
            formats:
                [
                    { key: 'sentToPA', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'transactionType', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'transactionSubCategory', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'invoiceNumber', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'gtesStatus', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'lifeCycleStatus', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'lifecycleActionTaken', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'lifecycleActionStatus', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'ppfStatus', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'fileId', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'docTyp', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'documentdate', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'sellerName', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'sellerVatId', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'buyerName', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'buyerVAT', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'documentCurrency', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'invoiceValue', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'taxableValue', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'taxAmount', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'attachUrlExcel', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'lastActivity', isformat: false, isPipeFormat: false, default: "" }
                ]
        },
        INVMGMTIT: {
            headers:
                [
                    ['Sent to SDI||A1:A1', 'SDI Identifier||B1:B1', 'SDI RicevutaTransmissione DateandTime||C1:C1',
                        'SDI Response Status||D1:D1', 'SDI Response DateandTime||E1:E1', 'Invoice Status||F1:F1', 'Invoice Type||G1:G1',
                        'Document Number||H1:H1', 'Document Date||I1:I1', 'Seller Legal name||J1:J1', 'Seller VAT ID||K1:K1', 
                        'Buyer Legal Name||L1:L1', 'Buyer VAT ID||M1:M1', 'Invoice Total with VAT||N1:N1']
                ],
            columns:
                [
                    { key: 'sentToSDI', width: 15 },
                    { key: 'sdiIdentifier', width: 15 },
                    { key: 'sdiTransmission', width: 22 },
                    { key: 'sdiStatus', width: 18 },
                    { key: 'responseDt', width: 15 },
                    { key: 'recordStatus', width: 15 },
                    { key: 'invoiceType', width: 15 },
                    { key: 'documentNumber', width: 22 },
                    { key: 'documentdate', width: 15 },
                    { key: 'sellerLegalName', width: 15 },
                    { key: 'sellerVATID', width: 22 },
                    { key: 'buyerLegalName', width: 20 },
                    { key: 'buyerVATID', width: 15 },
                    { key: 'invTotalVAT', width: 15 }
                ],
            cells:
                ['A1', 'B1', 'C1', 'D1', 'E1', 'F1', 'G1', 'H1', 'I1', 'J1', 'K1', 'L1', 'M1', 'N1'],
            fileBaseName: 'InvoiceManagement_TableData_',
            formats:
                [
                    { key: 'sentToSDI', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'sdiIdentifier', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'sdiTransmission', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'sdiStatus', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'responseDt', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'recordStatus', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'invoiceType', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'documentNumber', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'documentdate', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'sellerLegalName', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'sellerVATID', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'buyerLegalName', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'buyerVATID', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'invTotalVAT', isformat: false, isPipeFormat: false, default: "" }
                ]
        },
        INVMGMTMY: {
            headers:
                [
                    ['Sent to IRBM||A1:A1', 'Invoice Status||B1:B1','Retry Count||C1:C1', 'IRBM UUID||D1:D1', 'Invoice Type Code||E1:E1', 
                        'Invoice Document Number||F1:F1', 'Invoice Document Date||G1:G1','Invoice Transmission Date||H1:H1','File Id||I1:I1','Supplier Name||J1:J1', 'Supplier TIN||K1:K1', 'Buyer name||L1:L1',
                        'Buyer TIN||M1:M1', 'Invoice Currency Code||N1:N1', 'Total Excluding Tax||O1:O1', 'Tax Amount||P1:P1', 'Total Including Tax||Q1:Q1', 'Cancellation Date||R1:R1','Cancellation Successful||S1:S1', 
                        'Last Activity||T1:T1']
                ],
            columns:
                [
                    { key: 'sentToIRBM', width: 15 },
                    { key: 'recordStatus', width: 15 },
                    { key: 'retry', width: 15 },
                    { key: 'irbmUUID', width: 15 },
                    { key: 'invoiceTypeCode', width: 20 },
                    { key: 'invoiceNumber', width: 30 },
                    { key: 'invoiceDocDate', width: 22 },
                    { key: 'invoiceTransDate', width: 30 },
                    { key: 'fileId', width: 15 },
                    { key: 'supplierName', width: 15 },
                    { key: 'supplierTIN', width: 15 },
                    { key: 'buyerName', width: 15 },
                    { key: 'buyerTIN', width: 15 },
                    { key: 'invoiceCurrencyCode', width: 22 },
                    { key: 'totalExTax', width: 20 },
                    { key: 'taxAmount', width: 15 },
                    { key: 'totalInTax', width: 20 },
                    { key: 'cancelDate', width: 20  },
                    { key: 'cancellationSuccess', width: 20  },
                    { key: 'lastActivity', width: 22 }
                ],
            cells:
                ['A1', 'B1', 'C1', 'D1', 'E1', 'F1', 'G1', 'H1', 'I1', 'J1', 'K1', 'L1', 'M1', 'N1', 'O1', 'P1','Q1','R1','S1','T1'],
            fileBaseName: 'InvoiceManagement_TableData_',
            formats:
                [
                    { key: 'sentToIRBM', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'recordStatus', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'retry', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'irbmUUID', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'invoiceTypeCode', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'invoiceNumber', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'invoiceDocDate', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'invoiceTransDate', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'fileId', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'supplierName', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'supplierTIN', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'buyerName', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'buyerTIN', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'invoiceCurrencyCode', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'totalExTax', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'taxAmount', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'totalInTax', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'cancelDate', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'cancellationSuccess', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'lastActivity', isformat: false, isPipeFormat: false, default: "" }
                ]
        },
        INVMGMTMYCON: {
            headers:
                [
                    ['GTES Consolidated Status||A1:A1', 'Invoice Status||B1:B1','Retry Count||C1:C1', 'IRBM UUID||D1:D1', 'Invoice Type Code||E1:E1', 
                        'Invoice Document Number||F1:F1', 'Invoice Document Date||G1:G1','Invoice Transmission Date||H1:H1','File Id||I1:I1','Supplier Name||J1:J1', 'Supplier TIN||K1:K1', 'Buyer name||L1:L1',
                        'Buyer TIN||M1:M1', 'Invoice Currency Code||N1:N1', 'Total Excluding Tax||O1:O1', 'Tax Amount||P1:P1', 'Total Including Tax||Q1:Q1', 'Cancellation Date||R1:R1','Cancellation Successful||S1:S1', 
                        'Approved/Declined By||T1:T1','Last Activity||U1:U1']
                ],
            columns:
                [
                    { key: 'consolStatus', width: 15 },
                    { key: 'recordStatus', width: 15 },
                    { key: 'retry', width: 15 },
                    { key: 'irbmUUID', width: 15 },
                    { key: 'invoiceTypeCode', width: 20 },
                    { key: 'invoiceNumber', width: 30 },
                    { key: 'invoiceDocDate', width: 22 },
                    { key: 'invoiceTransDate', width: 30 },
                    { key: 'fileId1', width: 15 },
                    { key: 'supplierName', width: 15 },
                    { key: 'supplierTIN', width: 15 },
                    { key: 'buyerName', width: 15 },
                    { key: 'buyerTIN', width: 15 },
                    { key: 'invoiceCurrencyCode', width: 22 },
                    { key: 'totalExTax', width: 20 },
                    { key: 'taxAmount', width: 15 },
                    { key: 'totalInTax', width: 20 },
                    { key: 'cancelDate', width: 20  },
                    { key: 'cancellationSuccess', width: 20  },
                    { key: 'consolAuthBy', width: 22 },
                    { key: 'lastActivity', width: 22 }
                ],
            cells:
                ['A1', 'B1', 'C1', 'D1', 'E1', 'F1', 'G1', 'H1', 'I1', 'J1', 'K1', 'L1', 'M1', 'N1', 'O1', 'P1','Q1','R1','S1','T1','U1'],
            fileBaseName: 'OutwardGTESConsolidated_TableData_',
            formats:
                [
                    { key: 'consolStatus', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'recordStatus', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'retry', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'irbmUUID', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'invoiceTypeCode', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'invoiceNumber', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'invoiceDocDate', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'invoiceTransDate', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'fileId1', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'supplierName', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'supplierTIN', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'buyerName', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'buyerTIN', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'invoiceCurrencyCode', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'totalExTax', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'taxAmount', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'totalInTax', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'cancelDate', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'cancellationSuccess', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'consolAuthBy', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'lastActivity', isformat: false, isPipeFormat: false, default: "" }
                ]
        },
        RECIPTSMY: {
            headers:
                [
                    ['GTES Consolidated Status||A1:A1', 'Receipt Status||B1:B1','Invoice Status||C1:C1', 'IRBM UUID||D1:D1', 'Invoice Type Code||E1:E1', 
                        'Consolidated E-Invoice Number||F1:F1', 'Receipt Number||G1:G1','Receipt Date||H1:H1','File Id||I1:I1','Supplier Name||J1:J1', 'Supplier TIN||K1:K1', 'Buyer Name||L1:L1',
                        'Buyer TIN||M1:M1', 'Invoice Currency Code||N1:N1', 'Total Excluding Tax||O1:O1', 'Tax Amount||P1:P1', 'Total Including Tax||Q1:Q1', 'Last Activity||R1:R1']
                ],
            columns:
                [
                    { key: 'consolidatedStatus', width: 30 },
                    { key: 'receiptStatus', width: 15 },
                    { key: 'recordStatus', width: 15 },
                    { key: 'irbmUUID', width: 15 },
                    { key: 'invoiceTypeCode', width: 20 },
                    { key: 'invoiceNumber', width: 15 },
                    { key: 'receiptNumber', width: 20 },
                    { key: 'receiptDate', width: 22 },
                    { key: 'fileId', width: 15 },
                    { key: 'supplierName', width: 15 },
                    { key: 'supplierTIN', width: 15 },
                    { key: 'buyerName', width: 15 },
                    { key: 'buyerTIN', width: 15 },
                    { key: 'invoiceCurrencyCode', width: 22 },
                    { key: 'totalExTax', width: 20 },
                    { key: 'taxAmount', width: 15 },
                    { key: 'totalInTax', width: 20 },
                    { key: 'lastActivity', width: 22 }
                ],
            cells:
                ['A1', 'B1', 'C1', 'D1', 'E1', 'F1', 'G1', 'H1', 'I1', 'J1', 'K1', 'L1', 'M1', 'N1', 'O1', 'P1','Q1','R1'],
            fileBaseName: 'ReceiptManagement_TableData_',
            formats:
                [
                    { key: 'consolidatedStatus', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'receiptStatus', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'recordStatus', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'retry', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'irbmUUID', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'invoiceTypeCode', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'invoiceNumber', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'receiptNumber', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'receiptDate', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'fileId', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'supplierName', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'supplierTIN', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'buyerName', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'buyerTIN', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'invoiceCurrencyCode', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'totalExTax', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'taxAmount', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'totalInTax', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'lastActivity', isformat: false, isPipeFormat: false, default: "" }
                ]
        },
        DT_MANUAL: {
            headers: [
                ['Date||A1:A1', 'System ID / User ID||B1:B1', 'Data Source||C1:C1', 'File Type||D1:D1', 'File ID||E1:E1', 'File Name||F1:F1', 'Status||G1:G1',
                    'Total Received||H1:H1', 'Transformation||I1:I1', 'Error_GTES||J1:J1', 'Success_GTES||K1:K1']
            ],
            columns:
                [
                    { key: 'Date', width: 15 },
                    { key: 'System_ID', width: 20 },
                    { key: 'Source', width: 20 },
                    { key: 'FileTemplate', width: 20 },
                    { key: 'FileID', width: 20 },
                    { key: 'OrgFileName', width: 35 },
                    { key: 'Status', width: 20 },
                    { key: 'Total_Received', width: 20 },
                    { key: 'Type', width: 20 },
                    { key: 'Active_Errors', width: 20 },
                    { key: 'Active', width: 20 },
                ],
            cells:
                ['A1', 'B1', 'C1', 'D1', 'E1', 'F1', 'G1', 'H1', 'I1', 'J1', 'K1'],
            fileBaseName: 'DataStatus_TableData_',
            formats:
                [
                    { key: 'Date', isformat: false, isPipeFormat: true, pipeType: 'date', pipeformat: 'yyyy-MM-dd HH:mm:ss', default: "-" },
                    { key: 'System_ID', isformat: false, isPipeFormat: false, default: "-", userNameDisplay: true },
                    {
                        key: 'Source', isformat: true, formats: {
                            WEB: { name: "Web Upload" },
                            SFTP: { name: "SFTP Upload" },
                            ASYNC: { name: 'Async API' }
                        }, isPipeFormat: false, default: "-"
                    },
                    { key: 'FileTemplate', isformat: false, isPipeFormat: false, default: "Standard invoice" },
                    { key: 'FileID', isformat: false, isPipeFormat: false, default: "-" },
                    { key: 'OrgFileName', isformat: false, isPipeFormat: false, default: "-" },
                    {
                        key: 'Status', isformat: true, formats: {
                            PREUPLOADED: { name: "Uploaded" },
                            UPLOADED: { name: "Uploaded" },
                            INPROGRESS: { name: "Inprogress - 50%" },
                            FAILED: { name: "Failed" },
                                PENDING: { name: "Pending with Attachments" },
                            PROCESSED: { name: "Processed" },
                            T_INPROGRESS: { name: "Inprogress" },
                            N_INPROGRESS: { name: "Inprogress - 90%" },
                            T_FAILED: { name: "Failed" }
                        }, isPipeFormat: false, default: "-"
                    },
                    { key: 'Total_Received', isformat: false, isPipeFormat: false, default: 0 },
                    { key: 'Type', isformat: false, isPipeFormat: false, default: "No Transformation" },
                    { key: 'Active_Errors', isformat: false, isPipeFormat: false, default: 0 },
                    { key: 'Active', isformat: false, isPipeFormat: false, default: 0 }
                ]
        },
        DT_AUTO: {
            headers: [
                ['Date||A1:A1', 'System ID / User ID||B1:B1', 'Data Source||C1:C1', 'File Type||D1:D1', 'File ID||E1:E1', 'File Name||F1:F1', 'Status||G1:G1',
                    'Total Received||H1:H1', 'Transformation||I1:I1', 'Error_GTES||J1:J1', 'Success_GTES||K1:K1', 'Inprogress_SDI||L1:L1', 'Success_SDI||M1:M1',
                    'Error_SDI||N1:N1']
            ],
            columns:
                [
                    { key: 'Date', width: 15 },
                    { key: 'System_ID', width: 20 },
                    { key: 'Source', width: 20 },
                    { key: 'FileTemplate', width: 20 },
                    { key: 'FileID', width: 20 },
                    { key: 'OrgFileName', width: 35 },
                    { key: 'Status', width: 20 },
                    { key: 'Total_Received', width: 20 },
                    { key: 'Type', width: 20 },
                    { key: 'Active_Errors', width: 20 },
                    { key: 'Active', width: 20 },
                    { key: 'In_Progress_KSeF', width: 20 },
                    { key: 'Success_KSeF', width: 20 },
                    { key: 'Errors_KSeF', width: 20 }
                ],
            cells:
                ['A1', 'B1', 'C1', 'D1', 'E1', 'F1', 'G1', 'H1', 'I1', 'J1', 'K1', 'L1', 'M1', 'N1'],
            fileBaseName: 'DataStatus_TableData_',
            formats:
                [
                    { key: 'Date', isformat: false, isPipeFormat: true, pipeType: 'date', pipeformat: 'yyyy-MM-dd HH:mm:ss', default: "-" },
                    { key: 'System_ID', isformat: false, isPipeFormat: false, default: "-", userNameDisplay: true },
                    {
                        key: 'Source', isformat: true, formats: {
                            WEB: { name: "Web Upload" },
                            SFTP: { name: "SFTP Upload" },
                            ASYNC: { name: 'Async API' }
                        }, isPipeFormat: false, default: "-"
                    },
                    { key: 'FileTemplate', isformat: false, isPipeFormat: false, default: "Standard invoice" },
                    { key: 'FileID', isformat: false, isPipeFormat: false, default: "-" },
                    { key: 'OrgFileName', isformat: false, isPipeFormat: false, default: "-" },
                    {
                        key: 'Status', isformat: true, formats: {
                            PREUPLOADED: { name: "Uploaded" },
                            UPLOADED: { name: "Uploaded" },
                            INPROGRESS: { name: "InProgress - 50%" },
                            FAILED: { name: "Failed" },
                                PENDING: { name: "Pending with Attachments" },
                            PROCESSED: { name: "Processed" },
                            T_INPROGRESS: { name: "InProgress" },
                            N_INPROGRESS: { name: "InProgress - 90%" },
                            T_FAILED: { name: "Failed" }
                        }, isPipeFormat: false, default: "-"
                    },
                    { key: 'Total_Received', isformat: false, isPipeFormat: false, default: 0 },
                    { key: 'Type', isformat: false, isPipeFormat: false, default: "No Transformation" },
                    { key: 'Active_Errors', isformat: false, isPipeFormat: false, default: 0 },
                    { key: 'Active', isformat: false, isPipeFormat: false, default: 0 },
                    { key: 'In_Progress_KSeF', isformat: false, isPipeFormat: false, default: 0 },
                    { key: 'Success_KSeF', isformat: false, isPipeFormat: false, default: 0 },
                    { key: 'Errors_KSeF', isformat: false, isPipeFormat: false, default: 0 }
                ]
        },
        GET_MOF: {
            headers:
                [
                    ['Request Initiation||A1:A1', 'Request Id||B1:B1', 'Initiated By||C1:C1', 'Subject||D1:D1', 'Criteria||E1:E1', 'From Period||F1:F1',
                        'To Period||G1:G1', 'Status||H1:H1']
                ],
            columns:
                [
                    { key: 'createDate', width: 25 },
                    { key: 'requestId', width: 25 },
                    { key: 'createdBy', width: 45 },
                    { key: 'subject', width: 15 },
                    { key: 'criteria', width: 15 },
                    { key: 'from', width: 20 },
                    { key: 'to', width: 20 },
                    { key: 'status', width: 15 }
                ],
            cells:
                ['A1', 'B1', 'C1', 'D1', 'E1', 'F1', 'G1', 'H1'],
            fileBaseName: 'Inward_Supplies_TableData_',
            formats:
                [
                    { key: 'createDate', isformat: false, isPipeFormat: false, default: "-" },
                    { key: 'requestId', isformat: false, isPipeFormat: false, default: "-" },
                    { key: 'createdBy', isformat: false, isPipeFormat: false, default: "-" },
                    {
                        key: 'subject', subkey: 'code', isformat: true, formats: {
                            subject1: { name: "Subject 1" },
                            subject2: { name: "Subject 2" },
                            subject3: { name: "Subject 3" },
                            subjectAuthorized: { name: "Subject Authorized" }
                        }, isPipeFormat: false, default: "-"
                    },
                    {
                        key: 'criteria', subkey: 'code', isformat: true, formats: {
                            detail: { name: "Detail" },
                            incremental: { name: "Incremental" },
                            range: { name: "Range" },
                            Issue: { name: "Issue Date" },
                            Invoicing:{name: "Invoicing Date" },
                            PermanentStorage: { name: "Permanent Storage Date" }
                        }, isPipeFormat: false, default: "-"
                    },
                    { key: 'from', isformat: false, isPipeFormat: true, pipeType: 'date', pipeformat: 'yyyy-MM-dd HH:mm:ss', timezone: '+01:00', default: "-" },
                    { key: 'to', isformat: false, isPipeFormat: true, pipeType: 'date', pipeformat: 'yyyy-MM-dd HH:mm:ss', timezone: '+01:00', default: "-" },
                    { key: 'status', isformat: false, isPipeFormat: true, pipeType: 'case', default: "-" }
                ]
        },
        FETCH_RO: {
            headers:
                [
                    ['Request Initiation||A1:A1', 'Requested Id||B1:B1', 'Requested By||C1:C1', 'Mode||D1:D1', 'From Period||E1:E1', 'To Period||F1:F1',
                        'Completion Date||G1:G1', 'Status||H1:H1']
                ],
            columns:
                [
                    { key: 'createdDate', width: 25 },
                    { key: 'requestId', width: 25 },
                    { key: 'userName', width: 45 },
                    { key: 'mode', width: 15 },
                    { key: 'from', width: 20 },
                    { key: 'to', width: 20 },
                    { key: 'updatedDate', width: 20 },
                    { key: 'status', width: 15 }
                ],
            cells:
                ['A1', 'B1', 'C1', 'D1', 'E1', 'F1', 'G1', 'H1'],
            fileBaseName: 'InwardInvoices_StatusDownload_',
            formats:
                [
                    { key: 'createdDate', isformat: false, isPipeFormat: true, pipeType: 'date', pipeformat: 'yyyy-MM-dd HH:mm:ss', default: "-" },
                    { key: 'requestId', isformat: false, isPipeFormat: false, default: "-" },
                    { key: 'userName', isformat: false, isPipeFormat: false, default: "-" },
                    { key: 'mode', isformat: false, isPipeFormat: false, default: "-" },
                    { key: 'from', isformat: false, isPipeFormat: true, pipeType: 'date', pipeformat: 'yyyy-MM-dd HH:mm:ss', default: "-" },
                    { key: 'to', isformat: false, isPipeFormat: true, pipeType: 'date', pipeformat: 'yyyy-MM-dd HH:mm:ss', default: "-" },
                    { key: 'updatedDate', isformat: false, isPipeFormat: true, pipeType: 'date', pipeformat: 'yyyy-MM-dd HH:mm:ss', default: "-" },
                    { key: 'status', isformat: false, isPipeFormat: true, pipeType: 'case', default: "-" }
                ]
        },
        FETCH_FR: {
            headers:
                [
                    ['Request Initiation||A1:A1', 'Request ID||B1:B1', 'Requested By||C1:C1', 'Mode||D1:D1', 'Completion Date||E1:E1', 'Status||F1:F1']
                ],
            columns:
                [
                    { key: 'requestInitiation', width: 25 },
                    { key: 'requestedId', width: 25 },
                    { key: 'requestedBy', width: 45 },
                    { key: 'mode', width: 15 },
                    { key: 'completionDate', width: 20 },
                    { key: 'status', width: 20 }
                ],
            cells:
                ['A1', 'B1', 'C1', 'D1', 'E1', 'F1'],
            fileBaseName: 'InwardInvoicesFetch_TableData_',
            formats:
                [
                    { key: 'requestInitiation', isformat: false, isPipeFormat: true, pipeType: 'date', pipeformat: 'yyyy-MM-dd HH:mm:ss', default: "-" },
                    { key: 'requestedId', isformat: false, isPipeFormat: false, default: "-" },
                    { key: 'requestedBy', isformat: false, isPipeFormat: false, default: "-" },
                    { key: 'mode', isformat: false, isPipeFormat: false, default: "-" },
                    { key: 'completionDate', isformat: false, isPipeFormat: true, pipeType: 'date', pipeformat: 'yyyy-MM-dd HH:mm:ss', default: "-" },
                    { key: 'status', isformat: false, isPipeFormat: true, pipeType: 'case', default: "-" }
                ]
        },
        FETCH_MY: {
            headers:
                [
                    ['Request Initiation||A1:A1', 'Requested Id||B1:B1', 'Requested By||C1:C1', 'Invoice Direction||D1:D1', 'Mode||E1:E1', 'From Period||F1:F1', 'To Period||G1:G1', 'Completion Date||H1:H1', 'Status||I1:I1']
                ],
            columns:
                [
                    { key: 'createdDate', width: 25 },
                    { key: 'requestId', width: 25 },
                    { key: 'userName', width: 45 },
                    { key: 'direction', width: 20 },
                    { key: 'mode', width: 15 },
                    { key: 'from', width: 20 },
                    { key: 'to', width: 20 },
                    { key: 'updatedDate', width: 30 },
                    { key: 'status', width: 15 }
                ],
            cells:
                ['A1', 'B1', 'C1', 'D1', 'E1', 'F1', 'G1', 'H1', 'I1'],
            fileBaseName: 'InwardInvoicesFetch_TableData_',
            formats:
                [
                    { key: 'createdDate', isformat: false, isPipeFormat: true, pipeType: 'date', pipeformat: 'yyyy-MM-dd HH:mm:ss', default: "-" },
                    { key: 'requestId', isformat: false, isPipeFormat: false, default: "-" },
                    { key: 'userName', isformat: false, isPipeFormat: false, default: "-" },
                    { key: 'direction', isformat: false, isPipeFormat: false, default: "-" },
                    { key: 'mode', isformat: false, isPipeFormat: false, default: "-" },
                    { key: 'from', isformat: false, isPipeFormat: true, pipeType: 'date', pipeformat: 'yyyy-MM-dd HH:mm:ss', default: "-" },
                    { key: 'to', isformat: false, isPipeFormat: true, pipeType: 'date', pipeformat: 'yyyy-MM-dd HH:mm:ss', default: "-" },
                    { key: 'updatedDate', isformat: false, isPipeFormat: true, pipeType: 'date', pipeformat: 'yyyy-MM-dd HH:mm:ss', default: "-" },
                    { key: 'status', isformat: false, isPipeFormat: true, pipeType: 'case', default: "-" }
                ]
        },
        FETCH_AU: {
            headers:
                [
                    ['Request Initiation||A1:A1', 'Source||B1:B1', 'Requested Id||C1:C1', 'Requested By||D1:D1', 'Party||E1:E1', 'Participant ID||F1:F1', 'Mode||G1:G1', 'From Period||H1:H1', 'To Period||I1:I1',
                        'Status||J1:J1', 'Total Fetched||K1:K1', 'Success||L1:L1', 'Error||M1:M1']
                ],
            columns:
                [
                    { key: 'createdDate', width: 25 },
                    { key: 'source', width: 25 },
                    { key: 'requestId', width: 25 },
                    { key: 'userName', width: 45 },
                    { key: 'party', width: 25 },
                    { key: 'participantID', width: 40 },
                    { key: 'mode', width: 20 },
                    { key: 'from', width: 20 },
                    { key: 'to', width: 20 },
                    { key: 'status', width: 15 },
                    { key: 'totalFetched', width: 20 },
                    { key: 'success', width: 20 },
                    { key: 'error', width: 20 }

                ],
            cells:
                ['A1', 'B1', 'C1', 'D1', 'E1', 'F1', 'G1', 'H1', 'I1', 'J1', 'K1', 'L1', 'M1'],
            fileBaseName: 'InwardInvoices_TotalFetchedDownload_',
            formats:
                [
                    { key: 'createDate', isformat: false, isPipeFormat: true, pipeType: 'date', pipeformat: 'yyyy-MM-dd HH:mm:ss', default: "-" },
                    { key: 'source', isformat: false, isPipeFormat: false, default: "-" },
                    { key: 'requestId', isformat: false, isPipeFormat: false, default: "-" },
                    { key: 'userName', isformat: false, isPipeFormat: false, default: "-" },
                    { key: 'party', isformat: false, isPipeFormat: false, default: "-" },
                    { key: 'participantID', isformat: false, isPipeFormat: false, default: "-" },

                    { key: 'mode', isformat: false, isPipeFormat: false, default: "-" },
                    { key: 'from', isformat: false, isPipeFormat: true, pipeType: 'date', pipeformat: 'yyyy-MM-dd HH:mm:ss', default: "-" },
                    { key: 'to', isformat: false, isPipeFormat: true, pipeType: 'date', pipeformat: 'yyyy-MM-dd HH:mm:ss', default: "-" },
                    { key: 'status', isformat: false, isPipeFormat: true, pipeType: 'case', default: "-" },
                    { key: 'totalFetched', isformat: false, isPipeFormat: false, default: "-" },
                    { key: 'success', isformat: false, isPipeFormat: false, default: "-" },
                    { key: 'error', isformat: false, isPipeFormat: false, default: "-" }
                ]
        },
        DT_SYNC_AUTO_PL: {
            headers:
                [
                    ['Date||A1:A1', 'Api Type||B1:B1', 'System ID||C1:C1', 'File Type||D1:D1', 'Total Received||E1:E1', 'Error_EY-Structure/Duplicate||F1:F1',
                        'Error_EY||G1:G1', 'Success_EY||H1:H1', 'Inprogress_KSeF||I1:I1', 'Success_KSeF||J1:J1', 'Errors_KSeF||K1:K1']
                ],
            columns:
                [
                    { key: 'Date', width: 10 },
                    //{ key: 'Source', width: 10 },
                    { key: 'ApiType', width: 15 },
                    { key: 'System_ID', width: 10 },
                    { key: 'FileType', width: 15 },
                    { key: 'Total_Received', width: 15 },
                    { key: 'Structure', width: 15 },
                    { key: 'Errors_EY', width: 15 },
                    { key: 'Success_EY', width: 15 },
                    { key: 'InProgress_Mof', width: 20 },
                    { key: 'Success_Mof', width: 15 },
                    { key: 'Errors_Mof', width: 15 }
                ],
            cells:
                ['A1', 'B1', 'C1', 'D1', 'E1', 'F1', 'G1', 'H1', 'I1', 'J1', 'K1'],
            fileBaseName: 'Datastatus_SyncData_TableData_',
            formats:
                [
                    { key: 'Date', isformat: false, isPipeFormat: false, default: "-" },
                    //{ key: 'Source', isformat: false, isPipeFormat: false, default: "-" },
                    { key: 'ApiType', isformat: false, isPipeFormat: false, default: "-" },
                    { key: 'System_ID', isformat: false, isPipeFormat: false, default: "-", userNameDisplay: true },
                    { key: 'FileType', isformat: false, isPipeFormat: false, default: "Standard Invoice" },
                    { key: 'Total_Received', isformat: false, isPipeFormat: false, default: "0" },
                    { key: 'Structure', isformat: false, isPipeFormat: false, default: "0" },
                    { key: 'Errors_EY', isformat: false, isPipeFormat: false, default: "0" },
                    { key: 'Success_EY', isformat: false, isPipeFormat: false, default: "0" },
                    { key: 'InProgress_Mof', isformat: false, isPipeFormat: false, default: "0" },
                    { key: 'Success_Mof', isformat: false, isPipeFormat: false, default: "0" },
                    { key: 'Errors_Mof', isformat: false, isPipeFormat: false, default: "0" },
                ]
        },
        DT_SYNC_AUTO_RO: {
            headers:
                [
                    ['Date||A1:A1', 'Api Type||B1:B1', 'System ID||C1:C1', 'File Type||D1:D1', 'Total Received||E1:E1', 'Error_EY-Structure/Duplicate||F1:F1',
                        'Error_EY||G1:G1', 'Success_EY||H1:H1', 'Inprogress_Mof||I1:I1', 'Success_MoF||J1:J1', 'Errors_MoF||K1:K1']
                ],
            columns:
                [
                    { key: 'Date', width: 10 },
                    //{ key: 'Source', width: 10 },
                    { key: 'ApiType', width: 15 },
                    { key: 'System_ID', width: 10 },
                    { key: 'FileType', width: 15 },
                    { key: 'Total_Received', width: 15 },
                    { key: 'Structure', width: 15 },
                    { key: 'Errors_EY', width: 15 },
                    { key: 'Success_EY', width: 15 },
                    { key: 'InProgress_Mof', width: 20 },
                    { key: 'Success_Mof', width: 15 },
                    { key: 'Errors_Mof', width: 15 }
                ],
            cells:
                ['A1', 'B1', 'C1', 'D1', 'E1', 'F1', 'G1', 'H1', 'I1', 'J1', 'K1'],
            fileBaseName: 'Datastatus_SyncData_TableData_',
            formats:
                [
                    { key: 'Date', isformat: false, isPipeFormat: false, default: "-" },
                    //{ key: 'Source', isformat: false, isPipeFormat: false, default: "-" },
                    { key: 'ApiType', isformat: false, isPipeFormat: false, default: "-" },
                    { key: 'System_ID', isformat: false, isPipeFormat: false, default: "-", userNameDisplay: true },
                    { key: 'FileType', isformat: false, isPipeFormat: false, default: "Standard Invoice" },
                    { key: 'Total_Received', isformat: false, isPipeFormat: false, default: "0" },
                    { key: 'Structure', isformat: false, isPipeFormat: false, default: "0" },
                    { key: 'Errors_EY', isformat: false, isPipeFormat: false, default: "0" },
                    { key: 'Success_EY', isformat: false, isPipeFormat: false, default: "0" },
                    { key: 'InProgress_Mof', isformat: false, isPipeFormat: false, default: "0" },
                    { key: 'Success_Mof', isformat: false, isPipeFormat: false, default: "0" },
                    { key: 'Errors_Mof', isformat: false, isPipeFormat: false, default: "0" },
                ]
        },
        DT_SYNC_AUTO_FR: {
            headers:
                [
                    ['Date||A1:A1', 'Api Type||B1:B1', 'System ID||C1:C1', 'File Type||D1:D1', 'Total Received||E1:E1', 'Error_EY-Structure/Duplicate||F1:F1',
                        'Error_EY||G1:G1', 'Success_EY||H1:H1', 'Inprogress_SDI||I1:I1', 'Success_SDI||J1:J1', 'Errors_SDI||K1:K1']
                ],
            columns:
                [
                    { key: 'Date', width: 10 },
                    //{ key: 'Source', width: 10 },
                    { key: 'ApiType', width: 15 },
                    { key: 'System_ID', width: 10 },
                    { key: 'FileType', width: 15 },
                    { key: 'Total_Received', width: 15 },
                    { key: 'Structure', width: 15 },
                    { key: 'Errors_EY', width: 15 },
                    { key: 'Success_EY', width: 15 },
                    { key: 'InProgress_Mof', width: 20 },
                    { key: 'Success_Mof', width: 15 },
                    { key: 'Errors_Mof', width: 15 }
                ],
            cells:
                ['A1', 'B1', 'C1', 'D1', 'E1', 'F1', 'G1', 'H1', 'I1', 'J1', 'K1'],
            fileBaseName: 'Datastatus_SyncData_TableData_',
            formats:
                [
                    { key: 'Date', isformat: false, isPipeFormat: false, default: "-" },
                    //{ key: 'Source', isformat: false, isPipeFormat: false, default: "-" },
                    { key: 'ApiType', isformat: false, isPipeFormat: false, default: "-" },
                    { key: 'System_ID', isformat: false, isPipeFormat: false, default: "-", userNameDisplay: true },
                    { key: 'FileType', isformat: false, isPipeFormat: false, default: "Standard Invoice" },
                    { key: 'Total_Received', isformat: false, isPipeFormat: false, default: "0" },
                    { key: 'Structure', isformat: false, isPipeFormat: false, default: "0" },
                    { key: 'Errors_EY', isformat: false, isPipeFormat: false, default: "0" },
                    { key: 'Success_EY', isformat: false, isPipeFormat: false, default: "0" },
                    { key: 'InProgress_Mof', isformat: false, isPipeFormat: false, default: "0" },
                    { key: 'Success_Mof', isformat: false, isPipeFormat: false, default: "0" },
                    { key: 'Errors_Mof', isformat: false, isPipeFormat: false, default: "0" },
                ]
        },
        DT_SYNC_AUTO_IT: {
            headers:
                [
                    ['Date||A1:A1', 'Api Type||B1:B1', 'System ID||C1:C1', 'File Type||D1:D1', 'Total Received||E1:E1', 'Error_EY-Structure/Duplicate||F1:F1',
                        'Error_EY||G1:G1', 'Success_EY||H1:H1', 'Inprogress_SDI||I1:I1', 'Success_SDI||J1:J1', 'Error_SDI||K1:K1']
                ],
            columns:
                [
                    { key: 'Date', width: 10 },
                    //{ key: 'Source', width: 10 },
                    { key: 'ApiType', width: 15 },
                    { key: 'System_ID', width: 10 },
                    { key: 'FileType', width: 15 },
                    { key: 'Total_Received', width: 15 },
                    { key: 'Structure', width: 15 },
                    { key: 'Errors_EY', width: 15 },
                    { key: 'Success_EY', width: 15 },
                    { key: 'InProgress_Mof', width: 20 },
                    { key: 'Success_Mof', width: 15 },
                    { key: 'Errors_Mof', width: 15 }
                ],
            cells:
                ['A1', 'B1', 'C1', 'D1', 'E1', 'F1', 'G1', 'H1', 'I1', 'J1', 'K1'],
            fileBaseName: 'Datastatus_SyncData_TableData_',
            formats:
                [
                    { key: 'Date', isformat: false, isPipeFormat: false, default: "-" },
                    //{ key: 'Source', isformat: false, isPipeFormat: false, default: "-" },
                    { key: 'ApiType', isformat: false, isPipeFormat: false, default: "-" },
                    { key: 'System_ID', isformat: false, isPipeFormat: false, default: "-", userNameDisplay: true },
                    { key: 'FileType', isformat: false, isPipeFormat: false, default: "Standard Invoice" },
                    { key: 'Total_Received', isformat: false, isPipeFormat: false, default: "0" },
                    { key: 'Structure', isformat: false, isPipeFormat: false, default: "0" },
                    { key: 'Errors_EY', isformat: false, isPipeFormat: false, default: "0" },
                    { key: 'Success_EY', isformat: false, isPipeFormat: false, default: "0" },
                    { key: 'InProgress_Mof', isformat: false, isPipeFormat: false, default: "0" },
                    { key: 'Success_Mof', isformat: false, isPipeFormat: false, default: "0" },
                    { key: 'Errors_Mof', isformat: false, isPipeFormat: false, default: "0" },
                ]
        },
        DT_SYNC_MANUAL: {
            headers:
                [
                    ['Date||A1:A1', 'Api Type||B1:B1', 'System ID||C1:C1', 'File Type||D1:D1', 'Total Received||E1:E1', 'Error_EY-Structure/Duplicate||F1:F1',
                        'Error_EY||G1:G1', 'Success_EY||H1:H1']
                ],
            columns:
                [
                    { key: 'Date', width: 10 },
                    //{ key: 'Source', width: 10 },
                    { key: 'ApiType', width: 15 },
                    { key: 'System_ID', width: 10 },
                    { key: 'FileType', width: 15 },
                    { key: 'Total_Received', width: 15 },
                    { key: 'Structure', width: 15 },
                    { key: 'Errors_EY', width: 15 },
                    { key: 'Success_EY', width: 15 }
                ],
            cells:
                ['A1', 'B1', 'C1', 'D1', 'E1', 'F1', 'G1', 'H1'],
            fileBaseName: 'Datastatus_SyncData_TableData_',
            formats:
                [
                    { key: 'Date', isformat: false, isPipeFormat: false, default: "-" },
                    //{ key: 'Source', isformat: false, isPipeFormat: false, default: "-" },
                    { key: 'ApiType', isformat: false, isPipeFormat: false, default: "-" },
                    { key: 'System_ID', isformat: false, isPipeFormat: false, default: "-", userNameDisplay: true },
                    { key: 'FileType', isformat: false, isPipeFormat: false, default: "Standard Invoice" },
                    { key: 'Total_Received', isformat: false, isPipeFormat: false, default: "0" },
                    { key: 'Structure', isformat: false, isPipeFormat: false, default: "0" },
                    { key: 'Errors_EY', isformat: false, isPipeFormat: false, default: "0" },
                    { key: 'Success_EY', isformat: false, isPipeFormat: false, default: "0" },
                ]
        },
        REPORT_SCREEN: {
            headers:
                [
                    ['Request ID||A1:A1', 'Report Category||B1:B1', 'Report Type||C1:C1', 'Initiation On||D1:D1', 'Initiated By||E1:E1', 'Status||F1:F1']
                ],
            columns:
                [
                    { key: 'requestId', width: 15 },
                    { key: 'excelNameReportCategory', width: 15 },
                    { key: 'reportType', width: 15 },
                    { key: 'createdDate', width: 15 },
                    { key: 'createdBy', width: 15 },
                    { key: 'status', width: 15 }
                ],
            cells:
                ['A1', 'B1', 'C1', 'D1', 'E1', 'F1'],
            fileBaseName: 'Reports_Table Data_',
            formats:
                [
                    { key: 'requestId', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'excelNameReportCategory', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'reportType', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'createdDate', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'createdBy', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'status', isformat: false, isPipeFormat: false, default: "" }
                ]
        },
        INVOICE_IT: {
            headers:
                [
                    ['Document Number||A1:A1', 'Document Date||B1:B1', 'Document Type||C1:C1', 'Seller Legal Name||D1:D1', 'Seller VAT ID||E1:E1', 'Taxable Value||F1:F1',
                        'Tax Amount||G1:G1', 'Invoice Total with VAT||H1:H1', 'Attachment Exist||I1:I1','Response Date||J1:J1','Creation Date||K1:K1']
                ],
            columns:
                [
                    { key: 'docNum', width: 20 },
                    { key: 'docDate', width: 15 },
                    { key: 'docType', width: 15 },
                    { key: 'sellerLegalName', width: 20 },
                    { key: 'sellerVatId', width: 15 },
                    { key: 'taxableValue', width: 15 },
                    { key: 'taxAmount', width: 15 },
                    { key: 'invoiceTotalWithVat', width: 20 },
                    { key: 'attachmentExistExcel', width: 20 },
                    { key: 'responseDate', width: 15 }
                ],
            cells:
                ['A1', 'B1', 'C1', 'D1', 'E1', 'F1', 'G1', 'H1', 'I1','J1', 'K1'],
            fileBaseName: 'InboundInvoice_Table Data_',
            formats:
                [
                    { key: 'docNum', isformat: false, isPipeFormat: false, default: "-" },
                    { key: 'docDate', isformat: false, isPipeFormat: false, default: "-" },
                    { key: 'docType', isformat: false, isPipeFormat: false, default: "-" },
                    { key: 'sellerLegalName', isformat: false, isPipeFormat: false, default: "-" },
                    { key: 'sellerVatId', isformat: false, isPipeFormat: false, default: "-" },
                    { key: 'taxableValue', isformat: false, isPipeFormat: false, default: "-" },
                    { key: 'taxAmount', isformat: false, isPipeFormat: false, default: "-" },
                    { key: 'invoiceTotalWithVat', isformat: false, isPipeFormat: false, default: "-" },
                    { key: 'attachmentExistExcel', isformat: false, isPipeFormat: false, default: ""},
                    { key: 'responseDate', isformat: false, isPipeFormat: false, default: "-" },
                    { key: 'creationDate', isformat: false, isPipeFormat: false, default: "-" }
                ]
        },
        FETCH_IT: {
            headers:
                [
                    ['Request Initiation||A1:A1', 'Requested Id||B1:B1', 'Requested By||C1:C1', 'Mode||D1:D1', 'Completion Date||E1:E1', 'Status||F1:F1']
                ],
            columns:
                [
                    { key: 'createDate', width: 25 },
                    { key: 'requestId', width: 25 },
                    { key: 'userName', width: 45 },
                    { key: 'mode', width: 15 },
                    { key: 'updateDate', width: 20 },
                    { key: 'status', width: 15 }
                ],
            cells:
                ['A1', 'B1', 'C1', 'D1', 'E1', 'F1'],
            fileBaseName: 'InwardInvoicesFetch_TableData_',
            formats:
                [
                    { key: 'createDate', isformat: false, isPipeFormat: true, pipeType: 'date', pipeformat: 'yyyy-MM-dd HH:mm:ss', default: "-" },
                    { key: 'requestId', isformat: false, isPipeFormat: false, default: "-" },
                    { key: 'userName', isformat: false, isPipeFormat: false, default: "-" },
                    { key: 'mode', isformat: false, isPipeFormat: false, default: "-" },
                    { key: 'updateDate', isformat: false, isPipeFormat: true, pipeType: 'date', pipeformat: 'yyyy-MM-dd HH:mm:ss', default: "-" },
                    { key: 'status', isformat: false, isPipeFormat: true, pipeType: 'case', default: "-" }
                ]
        },
        INVOICE_RO: {
            headers:
            [
                ['Download Index||A1:A1', 'MoF Date||B1:B1', 'System Name||C1:C1','Buyer Legal Name||D1:D1', 'Buyer VAT ID||E1:E1', 'Seller Legal Name||F1:F1', 'Seller VAT ID||G1:G1',
                    'Invoice Type||H1:H1', 'Invoice Number||I1:I1', 'Invoice Currency Code||J1:J1', 'Invoice Date||K1:K1', 'VAT Point Date||L1:L1',
                    'Invoice VAT Taxable Amount||M1:M1', 'Invoice Total VAT Amount ||N1:N1','Attachment Exist||O1:O1', 'Invoice Total with VAT||P1:P1', 'Message Sent||Q1:Q1',
                    'Last Message Status||R1:R1'
                ]
            ],
            columns:
                [
                    
                    { key: 'downloadIndex', width: 15 },
                    { key: 'mofDate', width: 15 },
                    { key: 'sysName', width: 15 },
                    { key: 'buyerLegalName', width: 20 },
                    { key: 'buyerVatId', width: 20 },
                    { key: 'sellerLegalName', width: 20 },
                    { key: 'sellerVatId', width: 15 },
                    { key: 'invoiceType', width: 15 },
                    { key: 'invoiceNumber', width: 20 },
                    { key: 'invoiceCurrencyCode', width: 15 },
                    { key: 'invoiceDate', width: 15 },
                    { key: 'vatPointDate', width: 15 },
                    { key: 'invoiceVatTaxableAmount', width: 20 },
                    { key: 'invoiceTotalVatAmount', width: 20 },
                    { key: 'attachmentExistExcel', width: 20 },

                    { key: 'invoiceTotalWithVat', width: 20 },
                    { key: 'messageSent', width: 20 },
                    { key: 'lastMessageStatusWithDate', width: 20 }
                ],
            cells:
            ['A1', 'B1', 'C1', 'D1', 'E1', 'F1', 'G1', 'H1', 'I1', 'J1', 'K1', 'L1', 'M1', 'N1', 'O1', 'P1','Q1','R1'],
            fileBaseName: 'InwardInvoices_TableData_',
            formats:
                [
                    // { key: 'party', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'downloadIndex', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'mofDate', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'sysName', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'buyerLegalName', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'buyerVatId', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'sellerLegalName', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'sellerVatId', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'invoiceType', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'invoiceNumber', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'invoiceCurrencyCode', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'invoiceDate', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'vatPointDate', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'invoiceVatTaxableAmount', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'invoiceTotalVatAmount', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'attachmentExistExcel', isformat: false, isPipeFormat: false, default: ""},
                    { key: 'invoiceTotalWithVat', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'messageSent', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'lastMessageStatusWithDate', isformat: false, isPipeFormat: false, default: "" },
                ]
        },
        INVOICE_MY: {
            headers:
                [
                    ['IRBM Status||A1:A1', 'IRBM UUID||B1:B1', 'IRBM Validation Date||C1:C1', 'Invoice Type Code||D1:D1', 'Invoice Document Number||E1:E1', 'Invoice Issuance Date||F1:F1', 'Buyer Name||G1:G1',
                        'Buyer TIN||H1:H1', 'Supplier Name||I1:I1', 'Supplier TIN||J1:J1', 'Total Net Amount||K1:K1', 'Total Payable||L1:L1',
                        'Cancellation Date||M1:M1', 'Last Activity||N1:N1'
                    ]
                ],
            columns:
                [

                    { key: 'irbmStatus', width: 15 },
                    { key: 'irbmUUID', width: 15 },
                    { key: 'irbmValidationDate', width: 15 },
                    { key: 'invoiceTypeCode', width: 20 },
                    { key: 'invoiceDocNumber', width: 20 },
                    { key: 'invoiceIssuanceDate', width: 20 },
                    { key: 'buyerName', width: 15 },
                    { key: 'buyerTin', width: 15 },
                    { key: 'supplierName', width: 20 },
                    { key: 'supplierTin', width: 15 },
                    { key: 'totalNetAmount', width: 15 },
                    { key: 'totalPayable', width: 15 },
                    { key: 'cancellationDate', width: 20 },
                    { key: 'lastActivity', width: 20 }
                ],
            cells:
                ['A1', 'B1', 'C1', 'D1', 'E1', 'F1', 'G1', 'H1', 'I1', 'J1', 'K1', 'L1', 'M1', 'N1'],
            fileBaseName: 'InwardInvoices_TableData_',
            formats:
                [
                    { key: 'irbmStatus', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'irbmUUID', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'irbmValidationDate', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'invoiceTypeCode', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'invoiceDocNumber', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'invoiceIssuanceDate', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'buyerName', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'buyerTin', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'supplierName', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'supplierTin', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'totalNetAmount', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'totalPayable', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'cancellationDate', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'lastActivity', isformat: false, isPipeFormat: false, default: "" }
                ]
        },
        INVOICE_FR: {
            headers:
                [
                    ['Transaction Type||A1:A1', 'Transaction Sub Category||B1:B1', 'Document Number||C1:C1', 'Lifecycle Status||D1:D1', 'PPF Status||E1:E1', 'Doc Type||F1:F1',
                        'Document Date||G1:G1', 'Seller Name||H1:H1', 'Seller VAT ID||I1:I1', 'Buyer Name||J1:J1', 'Buyer VAT ID||K1:K1', 'Currency||L1:L1',
                        'Invoice Value||M1:M1', 'Taxable Amount||N1:N1', 'Tax Amount||O1:O1', 'Attachment Exists||P1:P1', 'Last Activity||Q1:Q1']
                ],
            columns:
                [
                    { key: 'transactionType', width: 20 },
                    { key: 'transactionSubCategory', width: 25 },
                    { key: 'documentNumber', width: 20 },
                    { key: 'lifecycleStatus', width: 18 },
                    { key: 'ppfStatus', width: 18 },
                    { key: 'docType', width: 15 },
                    { key: 'documentDate', width: 15 },
                    { key: 'sellerName', width: 20 },
                    { key: 'sellerVatId', width: 20 },
                    { key: 'buyerName', width: 20 },
                    { key: 'buyerVatId', width: 20 },
                    { key: 'currency', width: 15 },
                    { key: 'invoiceValue', width: 15 },
                    { key: 'taxableAmount', width: 15 },
                    { key: 'taxAmount', width: 15 },
                    { key: 'attachmentExists', width: 18 },
                    { key: 'lastActivity', width: 20 }
                ],
            cells:
                ['A1', 'B1', 'C1', 'D1', 'E1', 'F1', 'G1', 'H1', 'I1', 'J1', 'K1', 'L1', 'M1', 'N1', 'O1', 'P1', 'Q1'],
            fileBaseName: 'InwardInvoices_TableData_',
            formats:
                [
                    { key: 'transactionType', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'transactionSubCategory', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'documentNumber', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'lifecycleStatus', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'ppfStatus', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'docType', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'documentDate', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'sellerName', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'sellerVatId', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'buyerName', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'buyerVatId', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'currency', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'invoiceValue', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'taxableAmount', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'taxAmount', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'attachmentExists', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'lastActivity', isformat: false, isPipeFormat: false, default: "" }
                ]
        },
        INWARD_INVOICE_FR: {
            headers:
                [
                    ['Transaction Type||A1:A1', 'Transaction Sub Category||B1:B1', 'Document Number||C1:C1', 'Lifecycle Status||D1:D1','Lifecycle Action Taken||E1:E1','Lifecycle Action Status||F1:F1', 'PPF Status||G1:G1', 'System Name||H1:H1',
                        'Document Type||I1:I1', 'Document Date||J1:J1', 'Seller Name||K1:K1', 'Seller Legal ID||L1:L1', 'Buyer Name||M1:M1', 'Buyer Legal ID||N1:N1',
                        'Currency||O1:O1', 'Invoice Value||P1:P1', 'Taxable Amount||Q1:Q1', 'Tax Amount||R1:R1', 'Attachment Exist||S1:S1',
                        'Response Date||T1:T1', 'Creation Date||U1:U1', 'Last Activity||V1:V1']
                ],
            columns:
                [
                    { key: 'transactionType', width: 20 },
                    { key: 'subCategory', width: 25 },
                    { key: 'documentNumber', width: 20 },
                    { key: 'lifeCycleStatus', width: 18 },
                    { key: 'lifecycleActionTaken', width: 20 },
                    { key: 'lifecycleActionStatus', width: 20 },
                    { key: 'governmentStatus', width: 18 },
                    { key: 'systemName', width: 15 },
                    { key: 'docTyp', width: 15 },
                    { key: 'documentDate', width: 20 },
                    { key: 'sellerName', width: 20 },
                    { key: 'sellerVatId', width: 20 },
                    { key: 'buyerName', width: 20 },
                    { key: 'buyerVatId', width: 20 },
                    { key: 'currencyCode', width: 15 },
                    { key: 'invoiceAmount', width: 15 },
                    { key: 'taxableAmount', width: 15 },
                    { key: 'taxAmount', width: 15 },
                    { key: 'attachmentExist', width: 18 },
                    { key: 'responseDate', width: 20 },
                    { key: 'creationDate', width: 20 },
                    { key: 'lastActivity', width: 20 }
                ],
            cells:
                ['A1', 'B1', 'C1', 'D1', 'E1', 'F1', 'G1', 'H1', 'I1', 'J1', 'K1', 'L1', 'M1', 'N1', 'O1', 'P1', 'Q1', 'R1', 'S1', 'T1','U1','V1' ],
            fileBaseName: 'TableData_InwardInvoices_',
            formats:
                [
                    { key: 'transactionType', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'subCategory', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'documentNumber', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'lifeCycleStatus', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'lifecycleActionTaken', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'lifecycleActionStatus', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'governmentStatus', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'systemName', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'docTyp', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'documentDate', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'sellerName', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'sellerVatId', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'buyerName', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'buyerVatId', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'currencyCode', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'invoiceAmount', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'taxableAmount', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'taxAmount', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'attachmentExist', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'responseDate', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'creationDate', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'lastActivity', isformat: false, isPipeFormat: false, default: "" }
                ]
        },
        EREPORTING_FR: {
            headers:
                [
                    ['Send to PA||A1:A1', 'Transaction Type||B1:B1', 'Transaction Sub Category||C1:C1', 'Report Document ID||D1:D1','GTES Status||E1:E1','PPF Status||F1:F1', 'File ID||G1:G1', 'Transmission Type||H1:H1',
                        'Report Start Date||I1:I1', 'Report End Date||J1:J1', 'Report Issuer ID||K1:K1', 'Report Issuer Name||L1:L1', 'Reporter Role||M1:M1', 'Last Activity||N1:N1']
                ],
            columns:
                [
                    { key: 'sendToPA', width: 20 },
                    { key: 'transactionType', width: 20 },
                    { key: 'subCategory', width: 25 },
                    { key: 'reportDocumentId', width: 20 },
                    { key: 'gtesStatus', width: 18 },
                    { key: 'governmentStatus', width: 20 },
                    { key: 'fileId', width: 20 },
                    { key: 'codeTypeTransmission', width: 18 },
                    { key: 'periodStartDate', width: 20 },
                    { key: 'periodEndDate', width: 20 },
                    { key: 'reportIssuerId', width: 20 },
                    { key: 'reportIssuerName', width: 20 },
                    { key: 'reporterRole', width: 20 },
                    { key: 'lastActivity', width: 20 }
                ],
            cells:
                ['A1', 'B1', 'C1', 'D1', 'E1', 'F1', 'G1', 'H1', 'I1', 'J1', 'K1', 'L1', 'M1', 'N1' ],
            fileBaseName: 'TableData_EReporting_',
            formats:
                [
                    { key: 'sendToPA', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'transactionType', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'subCategory', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'reportDocumentId', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'gtesStatus', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'governmentStatus', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'fileId', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'codeTypeTransmission', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'periodStartDate', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'periodEndDate', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'reportIssuerId', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'reportIssuerName', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'reporterRole', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'lastActivity', isformat: false, isPipeFormat: false, default: "" }
                ]
        },
        INWARD_INVOICE_PL: {
            headers:
                [
                    ['Subject||A1:A1', 'Mode||B1:B1', 'Invoice Type||C1:C1', 'KSeF number||D1:D1', 'KSeF Date||E1:E1', 'System Name||F1:F1', 'Seller EU prefix||G1:G1', 'Seller tax ID||H1:H1',
                        'Seller name||I1:I1', 'Seller bank account||J1:J1', 'Buyer Tax ID||K1:K1', 'Buyer name||L1:L1', 'Currency code||M1:M1',
                        'Date of issue||N1:N1', 'Invoice number||O1:O1', 'Sales date || P1: P1', 'Sales 23% - net||Q1:Q1', 'Sales 23% - VAT||R1:R1',
                        'Sales 8% - net||S1:S1', 'Sales 8% - VAT||T1:T1', 'Sales 5% - net||U1:U1', 'Sales 5% - VAT||V1:V1', 'Sales in the OSS procedure - net||W1:W1',
                        'Sales in the OSS procedure - VAT||X1:X1', 'Sales 0% - net||Y1:Y1', 'Exempt sales||Z1:Z1', 'Gross value||AA1:AA1', 'Attachment exist||AB1:AB1',
                    ]
                ],
            columns:
                [
                    { key: 'subject', width: 15 },
                    { key: 'mode', width: 15 },
                    { key: 'invType', width: 15 },
                    { key: 'enum', width: 30 },
                    { key: 'edate', width: 15 },
                    { key: 'sysName', width: 15 },
                    { key: 'seuPrefix', width: 10 },
                    { key: 'svatId', width: 20 },
                    { key: 'seller', width: 15 },
                    { key: 'sbankAcc', width: 20 },
                    { key: 'cvatId', width: 20 },
                    { key: 'buyer', width: 15 },
                    { key: 'currencyCode', width: 10 },
                    { key: 'docDate', width: 20 },
                    { key: 'docNum', width: 20 },
                    { key: 'saleDate', width: 20 },
                    { key: 'sale23Net', width: 15 },
                    { key: 'sale23Vat', width: 15 },
                    { key: 'sale8Net', width: 15 },
                    { key: 'sale8Vat', width: 15 },
                    { key: 'sale5Net', width: 15 },
                    { key: 'sale5Vat', width: 15 },
                    { key: 'saleOssNet', width: 30 },
                    { key: 'saleOssVat', width: 30 },
                    { key: 'sale0net', width: 15 },
                    { key: 'exemptSales', width: 15 },
                    { key: 'grossValue', width: 15 },
                    { key: 'attachmentExist', width: 20 }
                ],
            cells:
                ['A1', 'B1', 'C1', 'D1', 'E1', 'F1', 'G1', 'H1', 'I1', 'J1', 'K1', 'L1', 'M1', 'N1', 'O1', 'P1', 'Q1', 'R1', 
                'S1', 'T1', 'U1', 'V1', 'W1', 'X1', 'Y1','Z1', 'AA1', 'AB1'], 
            fileBaseName: 'InwardInvoices_TableData_',
            formats:
                [
                    { key: 'subject', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'mode', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'invType', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'enum', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'edate', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'sysName', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'seuPrefix', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'svatId', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'seller', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'sbankAcc', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'cvatId', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'buyer', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'currencyCode', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'docDate', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'docNum', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'saleDate', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'sale23Net', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'sale23Vat', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'sale8Net', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'sale8Vat', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'sale5Net', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'sale5Vat', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'saleOssNet', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'saleOssVat', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'sale0net', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'exemptSales', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'grossValue', isformat: false, isPipeFormat: false, default: "" },
                    { key: 'attachmentExist', isformat: false, isPipeFormat: false, default: "" }
                ]
        }
        
    }
}
